import { useCallback, useMemo, useState } from "react"

import { MoreHorizRoundedIcon, MoreVertRoundedIcon } from "@l2r-front/l2r-icons"

import { L2RMenu } from "../L2RMenu"
import { MoreButton } from "../MoreButton"

import type { MoreMenuProps } from "./MoreMenu.types"

export const MoreMenu = (props: MoreMenuProps) => {
    const {
        disabled = false,
        icon,
        menuConfig,
        color = "primary",
        direction = "vertical",
        size = "small",
        ...menuProps
    } = props

    const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null)

    const handleMenuOpen = useCallback((event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation()
        setMenuAnchor(event.currentTarget)
    }, [setMenuAnchor])

    const handleMenuClose = useCallback(() => {
        setMenuAnchor(null)
    }, [setMenuAnchor])

    const config = useMemo(() => {
        return menuConfig.filter((item) => {
            const { displayed = true } = item
            return displayed
        })
            .map((item) => {
                const { enabled = true, id, label, icon, props } = item
                return { disabled: !enabled, id, label, icon, props }
            })
    }, [menuConfig])

    if (config.length === 0) {
        return null
    }

    const buttonIcon = icon ? icon : direction === "vertical" ? MoreVertRoundedIcon : MoreHorizRoundedIcon

    return <>
        <MoreButton disabled={disabled} color={color} size={size} icon={buttonIcon} onClick={handleMenuOpen} />
        <L2RMenu
            anchorEl={menuAnchor}
            onClose={handleMenuClose}
            open={Boolean(menuAnchor)}
            menuConfig={config}
            {...menuProps}
        />
    </>
}
